import { ArrowRightIcon, LockKeyIcon } from '@phosphor-icons/react';
import { useSearchParams } from 'react-router-dom';

import { LinkButton } from '@/ui/button/Button';
import { Card } from '@/ui/Card';
import { PageHeader } from '@/shared/components/PageHeader';

export const LoginFailedPage = () => {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');

  if (reason === 'not-invited') {
    return (
      <div className="py-8 min-h-screen">
        <PageHeader title="Beta access required" />

        <Card radius="lg" padding="none" className="sm:mt-16 max-w-lg mx-auto p-8 shadow-sm">
          <div className="flex flex-col items-center text-center">
            <div className="rounded-full bg-brand-tint p-3 mb-4">
              <LockKeyIcon size={28} weight="duotone" className="text-brand-text" />
            </div>
            <h1 className="text-2xl font-bold text-fg mb-2">Zooid is in private beta</h1>
            <p className="text-fg-secondary mb-6 leading-normal">
              The email on your GitHub account hasn&apos;t been invited yet. Request access below and we&apos;ll email
              you when a spot opens up.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
              <LinkButton to="/signup" iconRight={<ArrowRightIcon size={16} />}>
                Request beta access
              </LinkButton>
              <LinkButton to="/login" variant="secondary">
                Back to sign in
              </LinkButton>
            </div>
          </div>
        </Card>
      </div>
    );
  }

  const error = searchParams.get('error') || 'Unknown error';
  const errorCode = searchParams.get('error_code') || '-';
  const provider = searchParams.get('provider') || 'Unknown provider';

  return (
    <div className="py-8 min-h-screen">
      <PageHeader title="User not found" />

      <Card radius="lg" padding="none" className="sm:mt-16 max-w-lg mx-auto p-8">
        <h1 className="heading-one mb-8">Login failed</h1>

        <div className="my-4 text-fg-secondary">
          <div>{`Provider: ${provider}`}</div>
          <div>{`Error code: ${errorCode}`}</div>
          <div>{`Error: ${error}`}</div>
        </div>

        <div className="flex my-4">
          <LinkButton to="/login" iconRight={<ArrowRightIcon size={16} />}>
            Go back to login page
          </LinkButton>
        </div>
      </Card>

      <footer className="flex justify-center items-center gap-4 flex-wrap my-8">
        <a
          href="https://docs.google.com/document/d/1VfBoGVguSoj5-r8NOcq72qZdGD0yoRx5E04drLrPgiM/edit?usp=sharing"
          className="hover:underline"
        >
          Terms and conditions
        </a>
        <div>|</div>
        <a
          href="https://docs.google.com/document/d/1yZ_9gworSTk6LNkXqVTYscd_9HoSYaL0g5w9HEpdTh4/edit?usp=sharing"
          className="hover:underline"
        >
          Acceptable Use Policy
        </a>
        <div>|</div>
        <a
          href="https://docs.google.com/document/d/1T33zx7ocKqyOQfEk_VS2I2o-y_qd3Y54lHKPK7SYvcg/edit?usp=sharing"
          className="hover:underline"
        >
          Privacy Policy
        </a>
      </footer>
    </div>
  );
};
